module.exports = __webpack_public_path__ + "img/dlmd.787ad79d.png";